import {Box, Button, Card, CardHeader, Container, Link, Modal, Grid} from '@mui/material';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Badge from '@mui/material/Badge';
import CardMedia from '@mui/material/CardMedia';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Page from '../components/Page';
import { useEffect, useState } from 'react';
import api from '../api';
import {Link as RouterLink, useNavigate, useLocation} from "react-router-dom";
import Pagination from '@mui/material/Pagination';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import {Icon} from "@iconify/react";
import listIcon from "@iconify/icons-eva/list-outline";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import calendarIcon from "@iconify/icons-eva/calendar-outline";
import joinIcon from "@iconify/icons-eva/plus-square-outline";
import editIcon from "@iconify/icons-eva/edit-2-outline";
import Swal from 'sweetalert2'
import { QRCodeCanvas } from 'qrcode.react';
import downloadIcon from "@iconify/icons-eva/download-outline";
import shareIcon from "@iconify/icons-eva/share-outline";
import copyIcon from "@iconify/icons-eva/copy-outline";


export default function Leagues() {
    const [data, setData] = useState({});
    const [page, setPage] = useState(1);
    const [openModal, setOpenModal] = useState(false);
    const [joinLeagueID, setJoinLeagueID] = useState(0);
    const [status, setStatus] = useState('');
    const [openQrModal, setOpenQrModal] = useState(false);
    const [qrLeague, setQrLeague] = useState(null);
    let navigate = useNavigate();
    const location = useLocation();
    const styleModal = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        boxShadow: 24,
        overflowY:'auto',
        textAlign:'center',
        p: 4,
    };


    useEffect(() => {
        loadData();
    },[page,status]);

    useEffect(() => {
        if (location.state?.reload) {
            loadData();
            window.history.replaceState({}, document.title);
        }
    }, [location]);

    useEffect(() => {
        const query = new URLSearchParams(location.search);
        const joinParam = query.get('join');
        if (joinParam) {
            joinLeagueByParam(joinParam);
        }
    }, [location.search]);

    const joinLeagueByParam = (id) => {
        api.post('/league/join', {league_id: id})
            .then(function(response) { return response; })
            .then(function(resultData) {
                if (resultData.success) {
                    loadData();
                    Swal.fire({
                        title: "Welcome!",
                        text: "You have successfully joined the league!",
                        icon: "success"
                    });
                } else {
                    Swal.fire({
                        title: "Notice",
                        text: resultData.message,
                        icon: "info"
                    });
                }
                navigate('/dashboard/leagues', { replace: true });
            });
    }

    const loadData = () => {

        api.get('/leagues?page='+page+(status != ""?'&status='+encodeURIComponent(status):'')).then(function(response) { return response; })
            .then(function(resultData) {
                if (resultData.success){
                    setData(resultData.data);
                }
            });
    }

    const joinLeague = () => {
        setOpenModal(false);
        api.post('/league/join',{league_id:joinLeagueID})
            .then(function(response) { return response; })
            .then(function(resultData) {
                if (resultData.success){
                    loadData();
                    Swal.fire({
                        title: "Good job!",
                        text: "You joined the league!",
                        icon: "success"
                    });
                }else{
                    Swal.fire({
                        title: "Error!",
                        text: resultData.message,
                        icon: "error"
                    });
                }
            });
    }
    const joinLeagueModal = (league_id) => {
        setJoinLeagueID(league_id);
        setOpenModal(true);
    }

    const handleChangePage = (event, value) => {
        setPage(value);
    };

    const handleOpenQr = (league) => {
        setQrLeague(league);
        setOpenQrModal(true);
    };

    const handleCloseQr = () => {
        setOpenQrModal(false);
        setQrLeague(null);
    };

    const downloadQR = () => {
        const canvas = document.getElementById('league-qr-code');
        if(canvas) {
            const pngUrl = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");
            let downloadLink = document.createElement("a");
            downloadLink.href = pngUrl;
            downloadLink.download = `league_${qrLeague?.league_id}_qr.png`;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
        }
        handleCloseQr();
    };

    const copyLink = () => {
        const link = window.location.origin + "/dashboard/leagues?join=" + qrLeague?.join_code;
        navigator.clipboard.writeText(link);
        Swal.fire({
             title: "Copied!",
             text: "Link copied to clipboard",
             icon: "success",
             timer: 1500,
             showConfirmButton: false
        });
        handleCloseQr();
    };

    const shareTelegram = () => {
        const link = window.location.origin + "/dashboard/leagues?join=" + qrLeague?.join_code;
        const text = `Join my league: ${qrLeague?.name}`;
        const url = `https://t.me/share/url?url=${encodeURIComponent(link)}&text=${encodeURIComponent(text)}`;
        window.open(url, '_blank');
        handleCloseQr();
    };


    return (
        <Page title="Leagues | eagles.uz">
            <Container>
                <Card sx={{mt:3}}>
                    <CardHeader title={ "Leagues "} action={
                        (api.getUserType() == 'manager' || api.getUserType() == 'admin') ? (
                            <Button variant="contained" component={RouterLink} to="/dashboard/leagues/create" startIcon={<Icon icon={joinIcon} />}>
                                Add
                            </Button>
                        ) : null
                    } />
                    <Box sx={{ p: 3, pb: 1 }} dir="ltr">
                        <FormControl key={'f1'} sx={{ m: 1, minWidth: 100 }}>
                            <InputLabel id="demo-simple-select-autowidth-label">Status</InputLabel>
                            <Select
                                id="level-select"
                                value={status}
                                label="Status"
                                onChange={(event)=>{setStatus(event.target.value)}}
                                key={'s1'}
                            >
                                <MenuItem value={''}>-All-</MenuItem>
                                <MenuItem value={"new"}>New</MenuItem>
                                <MenuItem value={"active"}>Active</MenuItem>
                                <MenuItem value={"finished"}>Finished</MenuItem>
                            </Select>
                        </FormControl>
                        {data?.data?.map((row) => (

                            <Card sx={{ display: 'flex',my:1 }} key={row.league_id}>
                                <Grid container spacing={2}>
                                    <Grid item md={4} sx={{ display: 'flex', alignItems: 'center' }} >
                                        <CardMedia
                                            component="img"
                                            sx={{ 
                                                width: 200,
                                                
                                            }}
                                            image={"https://files.eagles.uz/leagues/" + row.image + "?t=" + new Date().getTime()}
                                            alt="legue"
                                            style={{ objectFit:"cover" }}
                                        />
                                    </Grid>
                                    <Grid item md={8}>
                                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                            <CardContent sx={{ flex: '1 0 auto' }}>
                                                <Badge color={ row.status === "new"?"secondary":(row.status === "active"?"primary":"warning") } badgeContent={row.status.toUpperCase()}>
                                                    <Typography component="div" variant="h5">
                                                        {row.name}
                                                    </Typography>
                                                </Badge>
                                                <Typography variant="subtitle1" color="text.secondary" component="div">
                                                    {row.author}
                                                </Typography>
                                                <Typography variant="p" color="text.secondary" component="div">
                                                    <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }} >
                                                        <ListItem>
                                                            <ListItemAvatar>
                                                                <Avatar>
                                                                    <Icon icon={calendarIcon} />
                                                                </Avatar>
                                                            </ListItemAvatar>
                                                            <ListItemText primary="Starting time" secondary={row.begin_date} />
                                                        </ListItem>
                                                        <ListItem>
                                                            <ListItemAvatar>
                                                                <Avatar>
                                                                    <Icon icon={calendarIcon} />
                                                                </Avatar>
                                                            </ListItemAvatar>
                                                            <ListItemText primary="Finishing time" secondary={row.end_date} />
                                                        </ListItem>
                                                    </List>


                                                    <Button
                                                        variant="contained"
                                                        component={RouterLink}
                                                        to={"/dashboard/league/"+row.league_id+"/users"}
                                                        startIcon={<Icon icon={listIcon} />}
                                                    >Participants
                                                    </Button>

                                                    {row.user_id == api.getUserId() && (api.getUserType() == 'manager' || api.getUserType() == 'admin') ? (
                                                        <Button
                                                            sx={{ ml:1 }}
                                                            variant="contained"
                                                            color="warning"
                                                            component={RouterLink}
                                                            to={"/dashboard/leagues/edit/"+row.league_id}
                                                            startIcon={<Icon icon={editIcon} />}
                                                        >Edit
                                                        </Button>
                                                    ) : null}

                                                    {row.joined_user_id != api.getUserId() ? (
                                                        <Button
                                                            sx={{ ml:1 }}
                                                            variant="contained"
                                                            onClick={()=>joinLeagueModal(row.league_id)}
                                                            to={"#"}
                                                            startIcon={<Icon icon={joinIcon} />}
                                                        >Join
                                                        </Button>)
                                                    :""}
                                                    {row.league_type === 'private' ? (
                                                        <Button
                                                            sx={{ ml:1 }}
                                                            variant="contained"
                                                            color="info"
                                                            onClick={()=>handleOpenQr(row)}
                                                            startIcon={<Icon icon={shareIcon} />}
                                                        >
                                                            QR Code
                                                        </Button>
                                                    ) : null}
                                                </Typography>
                                            </CardContent>
                                        </Box>

                                    </Grid>
                                </Grid>
                            </Card>
                        ))}
                        <Pagination count={data.last_page} page={page} onChange={handleChangePage} color="primary" variant="outlined" shape="rounded" />
                    </Box>
                </Card>


            </Container>
            <Modal
                open={openModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={styleModal}>
                    <h2>Are you sure?</h2>
                    <Button variant="outlined" onClick={()=>setOpenModal(false)}  sx={{ mx:1 }}>No</Button>
                    <Button variant="outlined" onClick={joinLeague} sx={{ mx:1 }}>Yes</Button>
                </Box>
            </Modal>
            <Modal
                open={openQrModal}
                onClose={handleCloseQr}
                aria-labelledby="qr-modal-title"
                aria-describedby="qr-modal-description"
            >
                <Box sx={styleModal}>
                     <Typography id="qr-modal-title" variant="h6" component="h2" sx={{ mb: 2 }}>
                        Invite to {qrLeague?.name}
                    </Typography>
                    <Box sx={{ my: 2, display:'flex', justifyContent:'center' }}>
                        {qrLeague && (
                             <QRCodeCanvas 
                                id="league-qr-code" 
                                value={window.location.origin + "/dashboard/leagues?join=" + qrLeague?.league_id} 
                                size={200}
                                level={"H"}
                                includeMargin={true}
                             />
                        )}
                    </Box>
                    <Typography variant="body2" sx={{ mb: 2 }}>
                         Scan to join
                    </Typography>
                    
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <Button variant="outlined" startIcon={<Icon icon={downloadIcon} />} onClick={downloadQR} fullWidth>
                            Download QR Code
                        </Button>
                        <Button variant="outlined" startIcon={<Icon icon={shareIcon} />} onClick={shareTelegram} fullWidth>
                            Share via Telegram
                        </Button>
                        <Button variant="outlined" startIcon={<Icon icon={copyIcon} />} onClick={copyLink} fullWidth>
                            Copy Link
                        </Button>
                    </Box>
                     <Box sx={{ mt: 2 }}>
                        <Button onClick={handleCloseQr}>Close</Button>
                    </Box>
                </Box>
            </Modal>
        </Page>
    );
}